/*
 * Zaunfeld-Konfigurator – UI (ein Screen, Live-Preis).
 *
 * Einbindung:
 *   FeldKonfigurator.init({
 *     container: '#feld-konfigurator',
 *     daten: window.FELD_DATA,            // konfigurator-data.json
 *     adapter: FeldShopifyAdapter.erstelle({ handle: 'individuelles-zaunfeld' })
 *   });
 *
 * Adapter-Schnittstelle:
 *   addToCart(ergebnis, meta) -> Promise
 *   hinweisText (optional)
 */
(function () {
  'use strict';

  function formatEuro(x) {
    return x.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  }
  function formatMeter(m) {
    return m.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' m';
  }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* ---------- Skizze: ein Feld mit Maßpfeilen ---------- */

  function massLinieH(x1, x2, y, label, fs) {
    return '<line x1="' + x1 + '" y1="' + y + '" x2="' + x2 + '" y2="' + y + '" stroke="#6b675f" stroke-width="1"/>' +
      '<line x1="' + x1 + '" y1="' + (y - 5) + '" x2="' + x1 + '" y2="' + (y + 5) + '" stroke="#6b675f" stroke-width="1"/>' +
      '<line x1="' + x2 + '" y1="' + (y - 5) + '" x2="' + x2 + '" y2="' + (y + 5) + '" stroke="#6b675f" stroke-width="1"/>' +
      '<text x="' + ((x1 + x2) / 2) + '" y="' + (y - 4) + '" text-anchor="middle" font-size="' + fs + '" fill="#2b2b28" font-family="sans-serif">' + label + '</text>';
  }

  function massLinieV(x, y1, y2, label, fs) {
    return '<line x1="' + x + '" y1="' + y1 + '" x2="' + x + '" y2="' + y2 + '" stroke="#6b675f" stroke-width="1"/>' +
      '<line x1="' + (x - 5) + '" y1="' + y1 + '" x2="' + (x + 5) + '" y2="' + y1 + '" stroke="#6b675f" stroke-width="1"/>' +
      '<line x1="' + (x - 5) + '" y1="' + y2 + '" x2="' + (x + 5) + '" y2="' + y2 + '" stroke="#6b675f" stroke-width="1"/>' +
      '<text x="' + (x + 8) + '" y="' + ((y1 + y2) / 2) + '" dominant-baseline="middle" font-size="' + fs + '" fill="#2b2b28" font-family="sans-serif">' + label + '</text>';
  }

  function zeichneFeld(daten, modell, laengeCm, hoeheCm, mitMassen) {
    var latte = (daten.latten || []).filter(function (l) { return l.name === modell.latten_name; })[0] ||
      { breite_cm: 6, anzahl_pro_m: 9, form: 'halbrund' };
    var randR = mitMassen ? 70 : 4;
    var randU = mitMassen ? 34 : 4;
    var w = laengeCm + randR + 4;
    var h = hoeheCm + randU + 6;
    var svg = [];

    svg.push(ZaunSkizze.feld({
      x: 2,
      y: 4,
      laengeCm: laengeCm,
      hoeheCm: hoeheCm,
      latte: latte,
      skizze: modell.skizze || {},
      material: modell.material
    }));

    if (mitMassen) {
      var fs = Math.max(11, Math.min(18, laengeCm / 18));
      svg.push(massLinieH(2, 2 + laengeCm, hoeheCm + 24, formatMeter(laengeCm / 100), fs));
      svg.push(massLinieV(laengeCm + 18, 4, 4 + hoeheCm, hoeheCm + ' cm', fs));
    }

    return '<svg viewBox="0 0 ' + w.toFixed(0) + ' ' + h.toFixed(0) +
      '" xmlns="http://www.w3.org/2000/svg" style="width:100%;max-height:340px">' + svg.join('') + '</svg>';
  }

  /* ---------- Share-Link ---------- */

  function stateAusHash(daten) {
    var m = (location.hash || '').match(/fk=([^&]*)/);
    if (!m) return null;
    try {
      var p = new URLSearchParams(decodeURIComponent(m[1]));
      var s = {
        modellId: p.get('m') || null,
        laenge_m: parseFloat(p.get('l')) || null,
        hoehe_cm: parseInt(p.get('h'), 10) || null
      };
      if (s.modellId && !daten.modelle.some(function (mo) { return mo.id === s.modellId; })) s.modellId = null;
      return s;
    } catch (e) { return null; }
  }

  function hashAusState(state) {
    var p = new URLSearchParams();
    p.set('m', state.modellId);
    p.set('l', state.laenge_m);
    p.set('h', state.hoehe_cm);
    return '#fk=' + encodeURIComponent(p.toString());
  }

  /* ---------- Modal & Demo-Adapter ---------- */

  var modalWurzel = null;
  function zeigeModal(html) {
    schliesseModal();
    modalWurzel = document.createElement('div');
    modalWurzel.className = 'fk-modal-hintergrund';
    modalWurzel.innerHTML = '<div class="fk-modal">' + html +
      '<div class="fk-cta-zeile"><button type="button" class="fk-btn fk-btn-primaer" data-fk-modal-zu>Schließen</button></div></div>';
    modalWurzel.addEventListener('click', function (e) {
      if (e.target === modalWurzel || e.target.hasAttribute('data-fk-modal-zu')) schliesseModal();
    });
    document.body.appendChild(modalWurzel);
  }
  function schliesseModal() {
    if (modalWurzel) { modalWurzel.remove(); modalWurzel = null; }
  }

  function demoAdapter() {
    return {
      hinweisText: 'Demo-Modus: Es wird kein echter Warenkorb befüllt.',
      addToCart: function (ergebnis, meta) {
        zeigeModal(
          '<h3>Warenkorb (Demo)</h3>' +
          '<p><strong>' + esc(meta.zusammenfassung) + '</strong></p>' +
          '<p>Preis: <strong>' + formatEuro(ergebnis.shopPreis) + '</strong>' +
          (ergebnis.shopPreis !== ergebnis.verkaufspreis
            ? ' <small>(Kalkulation ' + formatEuro(ergebnis.verkaufspreis) + ', aufs Raster gerundet)</small>' : '') + '</p>' +
          '<p>Im Shop würde 1 × die Preis-Variante „' + Math.round(ergebnis.shopPreis) + ' €“ des Konfigurator-Produkts ' +
          'mit diesen Eigenschaften in den Warenkorb gelegt:</p>' +
          '<pre>' + esc(JSON.stringify(meta.eigenschaften, null, 2)) + '</pre>'
        );
        return Promise.resolve();
      }
    };
  }

  /* ---------- Hauptkomponente ---------- */

  function init(opts) {
    var container = typeof opts.container === 'string' ? document.querySelector(opts.container) : opts.container;
    var daten = opts.daten || window.FELD_DATA;
    var adapter = opts.adapter || demoAdapter();
    if (!container || !daten || typeof FeldLogic === 'undefined') {
      if (container) container.innerHTML = '<p>Konfigurator konnte nicht geladen werden (Daten oder Logik fehlen).</p>';
      return;
    }

    var modelle = daten.modelle.slice().sort(function (a, b) { return a.sortierung - b.sortierung; });
    var g = daten.grenzen;
    var state = stateAusHash(daten) || {};
    state.modellId = state.modellId || modelle[0].id;
    state.laenge_m = state.laenge_m || 2.5;
    state.hoehe_cm = state.hoehe_cm || 100;

    /* Statisches Grundgerüst einmal aufbauen, danach nur noch gezielt aktualisieren
       (damit Slider beim Ziehen nicht den Fokus verlieren). */
    var karten = modelle.map(function (m) {
      return '<button type="button" class="fk-karte" data-modell="' + m.id + '">' +
        '<div class="fk-karte-bild">' + zeichneFeld(daten, m, 200, 100, false) + '</div>' +
        '<h4>' + esc(m.name) + '</h4><small>' + esc(m.material) + '</small></button>';
    }).join('');

    container.innerHTML =
      '<div class="fk">' +
      '<h2>Individuelles Zaunfeld</h2>' +
      '<p class="fk-hilfe">Dein Wunschmaß passt nicht ins Standardsortiment? Kein Problem – wir fertigen dein Zaunfeld ' +
      'auf den Zentimeter genau, vormontiert und versandfertig.</p>' +
      (adapter.hinweisText ? '<div class="fk-hinweise">' + esc(adapter.hinweisText) + '</div>' : '') +
      '<h3 class="fk-abschnitt">1. Modell</h3>' +
      '<div class="fk-karten">' + karten + '</div>' +
      '<h3 class="fk-abschnitt">2. Wunschmaß</h3>' +
      '<div class="fk-masse">' +
      '<div class="fk-mass"><label for="fk-laenge">Feldlänge</label>' +
      '<div class="fk-mass-zeile"><input type="number" id="fk-laenge" inputmode="decimal" step="0.01" min="' + g.min_laenge_m + '"> <span class="fk-einheit">m</span></div>' +
      '<input type="range" id="fk-laenge-slider" step="0.05" min="' + g.min_laenge_m + '">' +
      '<div class="fk-spanne"><span>' + String(g.min_laenge_m).replace('.', ',') + ' m</span><span id="fk-laenge-max"></span></div></div>' +
      '<div class="fk-mass"><label for="fk-hoehe">Feldhöhe</label>' +
      '<div class="fk-mass-zeile"><input type="number" id="fk-hoehe" inputmode="numeric" step="' + g.hoehe_schritt_cm + '" min="' + g.min_hoehe_cm + '" max="' + g.max_hoehe_cm + '"> <span class="fk-einheit">cm</span></div>' +
      '<input type="range" id="fk-hoehe-slider" step="' + g.hoehe_schritt_cm + '" min="' + g.min_hoehe_cm + '" max="' + g.max_hoehe_cm + '">' +
      '<div class="fk-spanne"><span>' + g.min_hoehe_cm + ' cm</span><span>' + g.max_hoehe_cm + ' cm</span></div></div>' +
      '</div>' +
      '<div class="fk-skizze" id="fk-skizze"></div>' +
      '<div id="fk-ergebnis"></div>' +
      '</div>';

    var elLaenge = container.querySelector('#fk-laenge');
    var elLaengeSlider = container.querySelector('#fk-laenge-slider');
    var elHoehe = container.querySelector('#fk-hoehe');
    var elHoeheSlider = container.querySelector('#fk-hoehe-slider');

    function maxLaenge() { return FeldLogic.maxLaengeFuerModell(daten, state.modellId); }

    function syncEingaben() {
      var max = maxLaenge();
      elLaenge.max = max;
      elLaengeSlider.max = max;
      container.querySelector('#fk-laenge-max').textContent = String(max).replace('.', ',') + ' m';
      elLaenge.value = state.laenge_m;
      elLaengeSlider.value = state.laenge_m;
      elHoehe.value = state.hoehe_cm;
      elHoeheSlider.value = state.hoehe_cm;
      container.querySelectorAll('[data-modell]').forEach(function (btn) {
        btn.classList.toggle('gewaehlt', btn.getAttribute('data-modell') === state.modellId);
      });
    }

    function update() {
      var modell = modelle.filter(function (m) { return m.id === state.modellId; })[0];
      var erg = FeldLogic.berechneFeld(state, daten);

      var skizze = container.querySelector('#fk-skizze');
      if (erg.ok) {
        skizze.style.display = '';
        skizze.innerHTML = zeichneFeld(daten, modell, state.laenge_m * 100, state.hoehe_cm, true);
      } else {
        skizze.style.display = 'none';
      }

      var ziel = container.querySelector('#fk-ergebnis');
      if (!erg.ok) {
        ziel.innerHTML = '<div class="fk-fehler"><ul>' +
          erg.fehler.map(function (f) { return '<li>' + esc(f) + '</li>'; }).join('') + '</ul></div>';
        return;
      }

      var enthalten = [
        erg.latten.anzahl + ' Zaunlatten ' + esc(modell.name) + ', ' + erg.hoehe_cm + ' cm',
        erg.riegel.anzahl + ' × ' + esc(modell.riegel_anzeige) + ', ' + erg.riegel.laenge_cm + ' cm' +
          (erg.riegel.proReihe > 1 ? ' (2 Stück je Riegelreihe)' : ''),
        'Verschraubung & fertige Montage des Feldes'
      ];

      ziel.innerHTML =
        '<div class="fk-ergebnis">' +
        '<div class="fk-preis-zeile"><div><strong>' + esc(FeldLogic.zusammenfassung(state, daten)) + '</strong></div>' +
        '<div class="fk-preis">' + formatEuro(erg.shopPreis) + '<small>inkl. Montage, zzgl. Versand</small></div></div>' +
        '<ul class="fk-enthalten">' + enthalten.map(function (e) { return '<li>' + e + '</li>'; }).join('') + '</ul>' +
        '<div class="fk-versand">Versand: voraussichtlich ' + esc(erg.versand.art) + ' · Gewicht ca. ' +
        erg.gewichtKg.toLocaleString('de-DE') + ' kg</div>' +
        (erg.hinweise.length ? '<div class="fk-hinweise"><ul>' +
          erg.hinweise.map(function (h) { return '<li>' + esc(h) + '</li>'; }).join('') + '</ul></div>' : '') +
        '<div class="fk-cta-zeile">' +
        '<button type="button" class="fk-btn fk-btn-primaer" id="fk-warenkorb">In den Warenkorb</button>' +
        '<button type="button" class="fk-btn fk-btn-sekundaer" id="fk-teilen">Konfiguration teilen</button>' +
        '</div></div>';

      container.querySelector('#fk-warenkorb').addEventListener('click', function () { inDenWarenkorb(erg); });
      container.querySelector('#fk-teilen').addEventListener('click', teilen);

      try { history.replaceState(null, '', hashAusState(state)); } catch (e) { /* file:// o. ä. */ }
    }

    function inDenWarenkorb(erg) {
      var btn = container.querySelector('#fk-warenkorb');
      var text = FeldLogic.zusammenfassung(state, daten);
      var konfigId = 'FK-' + Date.now().toString(36).toUpperCase();
      var meta = {
        zusammenfassung: text,
        konfigId: konfigId,
        eigenschaften: {
          'Zaunfeld': erg.modell.name,
          'Maße': String(erg.laenge_m).replace('.', ',') + ' m × ' + erg.hoehe_cm + ' cm',
          '_Konfiguration': konfigId,
          '_Kalkulation': formatEuro(erg.verkaufspreis),
          '_Konfigurator_Typ': 'zaunfeld',
          '_Modell_ID': erg.modell.id,
          '_Modell_DB': erg.modell.modell_db,
          '_Laenge_cm': String(Math.round(erg.laenge_m * 100)),
          '_Hoehe_cm': String(erg.hoehe_cm),
          '_Lieferart': 'vormontiert',
          '_Regelversion': String(daten.version || 1),
          '_Latten_SKU': erg.latten.sku,
          '_Latten_Anzahl': String(erg.latten.anzahl),
          '_Riegel_SKU': erg.riegel.sku,
          '_Riegel_Anzahl': String(erg.riegel.anzahl),
          '_Schrauben_Anzahl': String(erg.schrauben.anzahl),
          '_Montage': 'ja'
        }
      };
      btn.disabled = true;
      btn.textContent = 'Wird hinzugefügt …';
      adapter.addToCart(erg, meta)
        .catch(function (err) {
          zeigeModal('<h3>Das hat leider nicht geklappt</h3><p>' + esc(err && err.message || err) +
            '</p><p>Bitte versuche es noch einmal oder ruf uns an.</p>');
        })
        .then(function () {
          btn.disabled = false;
          btn.textContent = 'In den Warenkorb';
        });
    }

    function teilen() {
      var url = location.href.split('#')[0] + hashAusState(state);
      var fertig = function () {
        zeigeModal('<h3>Konfiguration teilen</h3><p>Der Link wurde in die Zwischenablage kopiert:</p><pre>' + esc(url) + '</pre>');
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(fertig, fertig);
      } else { fertig(); }
    }

    /* ----- Events ----- */

    container.querySelectorAll('[data-modell]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.modellId = btn.getAttribute('data-modell');
        if (state.laenge_m > maxLaenge()) state.laenge_m = maxLaenge();
        syncEingaben();
        update();
      });
    });

    function bindMass(inputEl, sliderEl, setter) {
      inputEl.addEventListener('input', function () {
        setter(inputEl.value);
        sliderEl.value = inputEl.value;
        update();
      });
      sliderEl.addEventListener('input', function () {
        setter(sliderEl.value);
        inputEl.value = sliderEl.value;
        update();
      });
    }
    bindMass(elLaenge, elLaengeSlider, function (v) { state.laenge_m = parseFloat(String(v).replace(',', '.')) || 0; });
    bindMass(elHoehe, elHoeheSlider, function (v) { state.hoehe_cm = parseInt(v, 10) || 0; });

    syncEingaben();
    update();
  }

  window.FeldKonfigurator = { init: init };
}());
